import { NivosTheme } from 'types/theme'

const Types = {
  SET: '@@theme/SET'
}

export type Payload = NivosTheme

export { Types }
